import { getData } from "./requests/CRUD";

/**
 * Mirrors TeamMember::isTerminated() on the server: a termination date that
 * has arrived ends the account, a future one is a scheduled last day.
 * UTC, because the server compares against now() and the app runs on UTC.
 */
function terminationHasArrived(terminationDate) {
    if (!terminationDate) return false;
    const ymd = String(terminationDate).trim().split(/[ T]/)[0];
    return /^\d{4}-\d{2}-\d{2}$/.test(ymd) && ymd <= new Date().toISOString().slice(0, 10);
}

export function getSuperUsers() {
    // The Created By / Modified By filters offer active team members: the
    // people who can still be stamping rows. "Active" is TeamMember::isActive()
    // — STATUS_CODE 'active', not deleted, termination date not yet arrived.
    // 'Crawler' is what the listings crawler signs its rows with
    // (ListingSyncService::ACTOR); without it here the properties it adds
    // cannot be filtered for.
    let data = ['Auto', 'Crawler'];
    getData({tableCode:'TEAM',
        options:{
            filterType:'and',
            column: ['FIRST_NAME', 'LAST_NAME', 'STATUS_CODE', 'TERMINATION_DATE', 'DELETED'],
            filter: [{
                text: 'active',
                code: 'STATUS_CODE',
                type: 'exact',
            },
            {
                text: 'n',
                code: 'DELETED',
                type: 'exact',
            }],
            order: [{ 
                code: 'FIRST_NAME', 
                type: 'asc',
            },{ 
                code: 'LAST_NAME', 
                type: 'asc',
            }]
        },
        
    }).then((res)=>{
        if(res && res.success && res.data.length)
            res.data
                .filter((el)=>!terminationHasArrived(el.TERMINATION_DATE))
                .map((el)=>{
                    data.push(el.FIRST_NAME+" "+el.LAST_NAME)
                })
            data.push("UPLOADS");
    });
    return data;
}
